import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, Button, ComponentSync, LL_H_C, LL_V_L, ModuleFE_Dialog, ModuleFE_Toaster, SimpleListAdapter, TS_DropDown } from '@nu-art/thunderstorm-frontend/index';
import './Dialog_CopyTransition.scss';
import { DropDown_DefaultCaret } from '@app/styles/frontend/ui/consts';
import { ModuleFE_PathwayState } from '../../../../../../_entity/pathway-state/index.js';
import { ModuleFE_PathwayTransition } from '../../../../../../_entity/pathway-transition/index.js';
export class Dialog_CopyTransition extends ComponentSync {
    static show = (data) => {
        ModuleFE_Dialog.show({ content: _jsx(Dialog_CopyTransition, { ...data }) });
    };
    deriveStateFromProps(nextProps, state) {
        state.availableStates = ModuleFE_PathwayState.cache.filter(state => state.pathwayIds.includes(this.props.pathwayId));
        return state;
    }
    onSelectSourceState = (sourceState) => {
        this.setState({ sourceState: sourceState });
    };
    onSelectTargetState = (targetState) => {
        this.setState({ targetState: targetState });
    };
    onClickCopy = async () => {
        const { sourceState, targetState } = this.state;
        if (!sourceState || !targetState)
            return;
        await ModuleFE_PathwayTransition._v1.copyTransition({
            pathwayTransitionToCopy: this.props.transitionToCopy,
            targetStateId: targetState._id,
            sourceStateId: sourceState._id,
        }).executeSync();
        ModuleFE_Toaster.toastSuccess(`Transition & orders pasted into '${targetState.label}'`);
        ModuleFE_Dialog.close();
    };
    render() {
        const className = _className('quai-manager-ui__copy-dialog', this.props.className);
        return _jsxs(LL_V_L, { className: className, id: this.props.id, children: [this.renderHeader(), this.renderSourceState(), this.renderTargetState(), this.renderButtons()] });
    }
    renderHeader = () => {
        return _jsx(LL_H_C, { className: 'quai-manager-ui__copy-dialog__header', children: "Copy Transition" });
    };
    renderTargetState = () => {
        let adapterData = [...this.state.availableStates];
        const adapter = SimpleListAdapter(adapterData.filter(data => data._id !== this.state.sourceState?._id), state => _jsx(_Fragment, { children: `Target State: ${state.item.label}` }));
        return _jsx(TS_DropDown, { adapter: adapter, selected: this.state.targetState, placeholder: 'Select Target State', onSelected: this.onSelectTargetState, caret: DropDown_DefaultCaret });
    };
    renderSourceState = () => {
        let adapterData = [...this.state.availableStates];
        const adapter = SimpleListAdapter(adapterData.filter(data => data._id !== this.state.targetState?._id), state => _jsx(_Fragment, { children: `Source State: ${state.item.label}` }));
        return _jsx(TS_DropDown, { adapter: adapter, selected: this.state.sourceState, placeholder: 'Select Source State', onSelected: this.onSelectSourceState, caret: DropDown_DefaultCaret });
    };
    renderButtons = () => {
        const { sourceState, targetState } = this.state;
        return _jsx(Button, { variant: 'primary', className: 'quai-manager-ui__copy-dialog__button', disabled: !targetState?._id && !sourceState?._id, onClick: this.onClickCopy, children: "Copy Transition" }, 'copy-transition');
    };
}
//# sourceMappingURL=Dialog_CopyTransition.js.map